/**
 * 8px Punkt; live=true → Pulse 1.6s mit 16px Spread.
 * Statisch in waiting/submitted/evaluated/done; pulst in live-Phasen.
 */

interface LiveDotProps {
  live?: boolean;
  ok?: boolean;
}

export function LiveDot({ live, ok }: LiveDotProps) {
  const cls = live ? "dot dot--live" : ok ? "dot dot--ok" : "dot";
  return <span className={cls} aria-hidden="true" />;
}
